import React from "react";
import { useManageIPMSContext } from "./ManageIPMSContex";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getCookieData, getUserIdTokenForIPMSEmployid, setCookieData } from "../../helper/api";
import { GoalsAssessmentFlagStatusEnumTextCap, GoalsFlagStatusEnumTextCap } from "./constant";
import { formatAsSevenDigitNumber, getQuarterRanges } from "./convertionHealper";
import SingleSelect from "../../components/SingleSelect";

const HomePage = () => {
  const {
    assessmentData,
    selectedAssessmentPeriod, // Assuming this method exists
    GetEmployeeGoalsAssessmentData,
    GetIpmsAssessmentStatusDataList,
    dispatch,
  } = useManageIPMSContext();
  const [error, setError] = React.useState("");
  const selectedAssessmentPeriodDate = getCookieData("goalsDate");
  const navigate = useNavigate();
  const ipmsID = getUserIdTokenForIPMSEmployid();

  // Handle date selection
  const handleSelectDate = (value: string) => {
    if (value) {
      setCookieData("goalsDate", value);
      GetEmployeeGoalsAssessmentData({
        employee_id: Number(ipmsID),
        start_assessment_date: value,
      });
      // console.log(value);
      dispatch({
        type: "SET_SELECTED_ASSESSMENT_PERIOD",
        payload: value,
      });
    }
  };

  React.useEffect(() => {
    const value = getCookieData("goalsDate");
    if (value) {
      handleSelectDate(value);
    }
  }, []);

  return (
    <div className='container mx-auto'>
      <div className='grid lg:grid-cols-2 grid-cols-1 gap-4'>
        <div className=''>
            <div className='max-w-sm pb-10'>
            <label className='block mb-2 text-lg font-medium text-gray-900 dark:text-white'>
              Assessment Period
            </label>
            <SingleSelect
              value={(() => {
                const options = assessmentData?.assessment_periods.map((item) => ({
                  value: item.start_assessment_date,
                  label: moment(item.start_assessment_date).format("DD/MM/YYYY") +
                    " - " +
                    moment(item.end_assessment_date).format("DD/MM/YYYY")
                })) || [];
                return options.find(opt => opt.value === selectedAssessmentPeriodDate);
              })()}
              onChange={(option: any) => handleSelectDate(option?.value)}
              options={assessmentData?.assessment_periods.map((item) => ({
                value: item.start_assessment_date,
                label: moment(item.start_assessment_date).format("DD/MM/YYYY") +
                  " - " +
                  moment(item.end_assessment_date).format("DD/MM/YYYY")
              }))}
              placeholder="Select Assessment Period"
              className="mt-0 w-64"
            />
          </div>
          <div className='pb-5 px-5'>
            <ol className='relative border-l border-gray-200 dark:border-gray-700'>
              {assessmentData?.assessment_periods
                .filter((item) =>
                  item.start_assessment_date.includes(
                    selectedAssessmentPeriodDate || selectedAssessmentPeriod,
                  ),
                )
                .map((item) => (
                  <li key={item.start_assessment_date} className='mb-10 ml-6'>
                    <span className='absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -left-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900'>
                      <svg
                        className='w-2.5 h-2.5 text-blue-800 dark:text-blue-300'
                        aria-hidden='true'
                        xmlns='http://www.w3.org/2000/svg'
                        fill='currentColor'
                        viewBox='0 0 20 20'
                      >
                        <path d='M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z' />
                      </svg>
                    </span>
                    <h3 className='flex items-center mb-1 pb-4 text-lg font-semibold text-gray-900 dark:text-white'>
                      Goals{" "}
                      {moment(item.start_assessment_date).format("YYYY") +
                        " - " +
                        moment(item.end_assessment_date).format("YYYY")}
                    </h3>

                    <button
                      type='button'
                      onClick={() =>
                        navigate("/ipms_new/goal", {
                          state: {
                            start: assessmentData.assessment_periods.filter((item) =>
                              item.start_assessment_date.includes(
                                selectedAssessmentPeriodDate || selectedAssessmentPeriod,
                              ),
                            )[0].start_assessment_date,
                            end: assessmentData.assessment_periods.filter((item) =>
                              item.start_assessment_date.includes(
                                selectedAssessmentPeriodDate || selectedAssessmentPeriod,
                              ),
                            )[0].end_assessment_date,
                          },
                        })
                      }
                      className='inline-flex items-center px-4 mr-2 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-gray-100 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-gray-700'
                    >
                      Add & Edit Goals
                    </button>
                  </li>
                ))}
            </ol>
          </div>
          <div className='px-5'>
            <ol className='relative border-l border-gray-200 dark:border-gray-700'>
              {selectedAssessmentPeriodDate &&
                assessmentData?.assessment_periods
                  .filter((item) => item.start_assessment_date.includes(selectedAssessmentPeriodDate))
                  .map((item) => (
                    <li key={item.start_assessment_date} className='mb-10 ml-6'>
                      <span className='absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -left-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900'>
                        <svg
                          className='w-2.5 h-2.5 text-blue-800 dark:text-blue-300'
                          aria-hidden='true'
                          xmlns='http://www.w3.org/2000/svg'
                          fill='currentColor'
                          viewBox='0 0 20 20'
                        >
                          <path d='M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z' />
                        </svg>
                      </span>
                      <h3 className='flex items-center mb-1 pb-2 text-lg font-semibold text-gray-900 dark:text-white'>
                        Performance Assessment{" "}
                        {moment(item.start_assessment_date).format("YYYY") +
                          " - " +
                          moment(item.end_assessment_date).format("YYYY")}
                      </h3>

                      <div className="p-3 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 border border-blue-200 dark:bg-gray-800 dark:text-blue-400 dark:border-blue-800 flex items-center gap-2">
                        <svg className="w-4 h-4 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M10 0C4.612 0 0 4.612 0 10s4.612 10 10 10 10-4.612 10-10S15.388 0 10 0zm0 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1-5a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v4z"/>
                        </svg>
                        <span>
                          <strong>Note :</strong> Quaterly Assesments can only be filled for current and past quarters
                        </span>
                      </div>

                      {error && <p className='text-sm capitalize text-red-500 mb-5'>{error}</p>}
                      {Array.isArray(GetIpmsAssessmentStatusDataList) && GetIpmsAssessmentStatusDataList.length > 0 ? (
                        (() => {
                          const quarterRanges = getQuarterRanges(
                            moment(item.start_assessment_date),
                            moment(item.end_assessment_date)
                          );
                          const sortedData = [...GetIpmsAssessmentStatusDataList].sort(
                            (a, b) => a.quarter_number - b.quarter_number
                          );

                          return sortedData.map((quarterData, index, array) => {
                            const qIndex = quarterData.quarter_number - 1;
                            const qRange = quarterRanges[qIndex];
                            const isQuarterStarted = qRange
                              ? moment().isSameOrAfter(moment(qRange.start), "day")
                              : true;

                            const isDisabled = !isQuarterStarted;

                            return (
                              <button
                                key={quarterData.quarter_number}
                                disabled={isDisabled}
                                onClick={() => {
                                  if (!isQuarterStarted) {
                                    setError(
                                      `Quarterly Assessments can only be filled for current and past quarters. Quarter ${quarterData.quarter_number} will be enabled on ${moment(qRange?.start).format("DD/MM/YYYY")}.`
                                    );
                                    return;
                                  }
                                  if (
                                    ["APPROVED", "REJECTED"].includes(
                                      quarterData.goal_status
                                    )
                                  ) {
                                    setError("");
                                    navigate("/ipms_new/goalassessment", {
                                      state: {
                                        id: quarterData?.quarter_number,
                                        quarterName: quarterData?.quarter_number,
                                        employeeID: ipmsID,
                                        formType: "EmployeeInput",
                                        assessmentData: {
                                          start: item.start_assessment_date,
                                          end: item.end_assessment_date,
                                        },
                                      },
                                    });
                                  } else {
                                    const status = quarterData.goal_status;
                                    setError(
                                      status === GoalsFlagStatusEnumTextCap.SUBMITTED
                                        ? `Your goal has been submitted for the Quarter ${quarterData.quarter_number} and is waiting for manager approval.`
                                        : status !== undefined
                                          ? `Your goal has not been submitted. Please submit your goals.`
                                          : `Submission status is missing for the Quarter ${quarterData.quarter_number}. Please contact support.`
                                    );
                                  }
                                }}
                                className={`relative inline-flex items-center capitalize px-4 mr-2 my-2 py-2 text-sm font-medium border rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-gray-100 focus:text-blue-700 dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-gray-700
                                  ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}
                                  ${[GoalsAssessmentFlagStatusEnumTextCap.DRAFT, GoalsAssessmentFlagStatusEnumTextCap.READY].includes(quarterData.assessment_status)
                                    ? "bg-gray-100 text-gray-800 border-gray-500 dark:bg-gray-700 dark:text-gray-400 dark:border-gray-500"
                                    : [GoalsAssessmentFlagStatusEnumTextCap.SUBMITTED, GoalsAssessmentFlagStatusEnumTextCap.SUBMIT].includes(quarterData.assessment_status)
                                      ? "bg-blue-100 text-blue-800 border-blue-400 dark:bg-gray-700 dark:text-blue-400 dark:border-blue-400"
                                      : [GoalsAssessmentFlagStatusEnumTextCap.APPROVED].includes(quarterData.assessment_status)
                                        ? "bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-gray-700 dark:text-yellow-300 dark:border-yellow-300"
                                        : [GoalsAssessmentFlagStatusEnumTextCap.COMPLETED].includes(quarterData.assessment_status)
                                          ? "bg-green-100 text-green-800 border-green-400 dark:bg-gray-700 dark:text-green-400 dark:border-green-400"
                                          : "bg-white text-gray-900 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600"
                                  }
                                `}
                              >
                                Quarter {quarterData.quarter_number} - Performance
                                <span className={`ms-2 text-xs font-medium px-2.5 py-0.5 rounded border
                                  ${[GoalsAssessmentFlagStatusEnumTextCap.DRAFT, GoalsAssessmentFlagStatusEnumTextCap.READY].includes(quarterData.assessment_status)
                                    ? "bg-gray-100 text-gray-800 border-gray-500 dark:bg-gray-700 dark:text-gray-400 dark:border-gray-500"
                                    : [GoalsAssessmentFlagStatusEnumTextCap.SUBMITTED, GoalsAssessmentFlagStatusEnumTextCap.SUBMIT].includes(quarterData.assessment_status)
                                      ? "bg-blue-100 text-blue-800 border-blue-400 dark:bg-gray-700 dark:text-blue-400 dark:border-blue-400"
                                      : [GoalsAssessmentFlagStatusEnumTextCap.APPROVED].includes(quarterData.assessment_status)
                                        ? "bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-gray-700 dark:text-yellow-300 dark:border-yellow-300"
                                        : [GoalsAssessmentFlagStatusEnumTextCap.COMPLETED].includes(quarterData.assessment_status)
                                          ? "bg-green-100 text-green-800 border-green-400 dark:bg-gray-700 dark:text-green-400 dark:border-green-400"
                                          : "hidden"
                                  }
                                `}>
                                  {[GoalsAssessmentFlagStatusEnumTextCap.DRAFT, GoalsAssessmentFlagStatusEnumTextCap.READY].includes(quarterData.assessment_status) ? "Employee Saved" :
                                    [GoalsAssessmentFlagStatusEnumTextCap.SUBMITTED, GoalsAssessmentFlagStatusEnumTextCap.SUBMIT].includes(quarterData.assessment_status) ? "Employee Submitted" :
                                      [GoalsAssessmentFlagStatusEnumTextCap.APPROVED].includes(quarterData.assessment_status) ? "Manager Approved" :
                                        [GoalsAssessmentFlagStatusEnumTextCap.COMPLETED].includes(quarterData.assessment_status) ? "HR Approved" : ""}
                                </span>
                              </button>
                            );
                          });
                        })()
                      ) : (
                        <p className='text-sm'>No Goals Found</p>
                      )}
                      {/* <div className="flex flex-row justify-start items-center mt-4">
                        <span className="bg-gray-100 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500">
                          Employee Saved
                        </span>
                        <span className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-blue-400 border border-blue-400">
                          Employee Added
                        </span>
                        <span className="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-yellow-300 border border-yellow-300">
                          Manager Approved
                        </span>
                        <span className="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border border-green-400">
                          HR Approved
                        </span>
                      </div> */}
                    </li>
                  ))}
            </ol>

          </div>
        </div>
        <div className=''>
          <div className='pb-5 px-5'>
            <ol className='relative border-l border-gray-200 dark:border-gray-700'>
              {assessmentData?.user_data && (
                <li className='mb-10 ml-6'>
                  <span className='absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -left-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900'>
                    <svg
                      className='w-2.5 h-2.5 text-blue-800 dark:text-blue-300'
                      aria-hidden='true'
                      xmlns='http://www.w3.org/2000/svg'
                      fill='currentColor'
                      viewBox='0 0 20 20'
                    >
                      <path d='M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z' />
                    </svg>
                  </span>
                  <h3 className='flex items-center mb-1 pb-4 text-lg font-semibold text-gray-900 dark:text-white'>
                    My Profile
                  </h3>
                  <p>
                    <span className='font-bold'>Name:</span> {assessmentData?.user_data.username}
                  </p>
                  <p>
                    <span className='font-bold'>EmpID:</span>{" "}
                    {formatAsSevenDigitNumber(assessmentData?.user_data.employeeid)}{" "}
                  </p>
                  <p>
                    <span className='font-bold'>Designation:</span> {assessmentData?.user_data.designation}
                  </p>
                  <p>
                    <span className='font-bold'>Department:</span> {assessmentData?.user_data.department}{" "}
                  </p>
                  <p>
                    <span className='font-bold'>Delivery Doj:</span>{" "}
                    {moment(assessmentData?.user_data.doj).format("DD MMM YYYY")}{" "}
                  </p>
                </li>
              )}
            </ol>
          </div>
        </div>
      </div>
    </div >
  );
};

export default HomePage;
